import React, { useEffect } from 'react'
import tw, { styled } from 'twin.macro'
import Board from './Board'
import Welcome from './Welcome'
import EndScreen from './EndScreen'
import { useStateContext } from './../context/stateContext'
import { AnimatePresence } from 'framer-motion'
import bg from './../assets/bg-space.jpg'
import logo from './../assets/sk-logo.png'
import Popup from './Popup'

const Container = styled.div`
	${tw`relative flex items-center justify-center w-full h-screen overflow-hidden`}
`
const DesignBy = styled.p`
	${tw`absolute text-right text-white text-10px md:text-sm bottom-2 right-2 md:bottom-8 md:right-8`}
`
const DatenschutzButton = styled.button`
	${tw`absolute text-left text-white underline text-10px md:text-sm bottom-2 left-2 md:bottom-8 md:left-8`}
`
const BackgroundImage = styled.img`
	${tw`inset-0 object-cover w-full h-screen z-[-10]`}
`

const Screen = () => {
	const stateContext = useStateContext()
	const { loadSounds } = useStateContext()
	const gameContainerRef = React.useRef()

	const togglePopup = () => {
		stateContext.dispatch({ action: 'SET_POPUP_STATUS', data: true })
	}

	useEffect(() => {
		if (!stateContext.state.soundLoaded) {
			loadSounds()
		}
		gameContainerRef.current.addEventListener('contextmenu', (e) => {
			e.preventDefault()
		})
		return () => gameContainerRef.current.removeEventListener('contextmenu')
	}, []) // eslint-disable-line react-hooks/exhaustive-deps

	useEffect(() => {}, [stateContext.state.gameStatus])
	return (
		<Container ref={gameContainerRef}>
			<BackgroundImage key='bg-image' src={bg} alt='' />
			<AnimatePresence exitBeforeEnter initial={false}>
				<img className='absolute left-0 right-0 block h-[60px] sm:h-auto object-contain mx-auto mb-4 top-5 sm:top-10 md:top-14 ' src={logo} alt='' />
				{stateContext.state.gameStatus === 'beforeInit' && <Welcome key='welcome' />}
				{stateContext.state.gameStatus === 'gameStart' && <Board key='board' />}
				{stateContext.state.gameStatus === 'gameEnded' && <EndScreen key='endscreen' />}
			</AnimatePresence>
			{/* <DatenschutzButton href='https://www.schmitts-katze.de/datenschutz/' target='_blank'>
				AGBs
			</DatenschutzButton> */}
			<DatenschutzButton onClick={togglePopup}>Teilnahmebedingungen</DatenschutzButton>
			<DesignBy>
				designed & developed by <span className='block md:inline-block'>Hattenberger&nbsp;Partner</span>
			</DesignBy>
			{stateContext.state.popup && <Popup key='popup' />}
		</Container>
	)
}

export default Screen
